export default "__VITE_ASSET__Ct2f5tO5__"